import { BaseFlag } from "./Base";
import { NodeEvent } from "../../../poly/NodeEvent";
export class OptimizeFlag extends BaseFlag {
  constructor() {
    super(...arguments);
    this._state = false;
  }
  _on_update() {
    this.node.emit(NodeEvent.FLAG_OPTIMIZE_UPDATED);
  }
}
